module.exports = __webpack_public_path__ + "img/logo.87b59e2.png";